// Ren, DOM-fri opplastingsteller. Brukes av stale-bundle.ts til å utsette
// reload mens en pakke-/mottaksopplasting pågår -- nginx-loggen fra 22/7
// viste at POST /media fikk 499 i samme sekund som en reload trigget, fordi
// lageransatte kom tilbake fra kameraet midt i opplastingen rett etter en
// deploy.
//
// Nøstet begin/end (flere samtidige opplastinger) holdes med en enkel
// teller. Tvungen nullstilling etter FORCE_RESET_MS hindrer evig lås dersom
// en endUpload()-kall uteblir (f.eks. fanen ble drept midt i en fetch).
// Sjekkes lat i isUploadBusy/beginUpload/endUpload -- ingen setInterval.

const FORCE_RESET_MS = 5 * 60_000;

let count = 0;
let busySince: number | null = null;

function resetToIdle(): void {
  count = 0;
  busySince = null;
}

function forceResetIfStale(now: number): void {
  if (count > 0 && busySince !== null && now - busySince >= FORCE_RESET_MS) {
    resetToIdle();
  }
}

export function beginUpload(): void {
  const now = Date.now();
  forceResetIfStale(now);
  if (count === 0) {
    busySince = now;
  }
  count += 1;
}

export function endUpload(): void {
  const now = Date.now();
  forceResetIfStale(now);
  if (count === 0) return; // klem til 0: aldri negativ
  count -= 1;
  if (count === 0) {
    busySince = null;
  }
}

export function isUploadBusy(): boolean {
  forceResetIfStale(Date.now());
  return count > 0;
}
